import React, { useMemo } from 'react';

import { Card } from '#/shared/components/Card';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

import { mapShiftsToDayEntryList } from '../utils/helper';
import { TimesheetShiftEntryOrdinaryRow } from './TimesheetShiftEntryOrdinaryRow';
import { TimesheetShiftEntryRow } from './TimesheetShiftEntryRow';

export function TimesheetShiftDetails() {
  const shifts = useTimesheetStore(state => state.timesheet?.shifts ?? []);
  const timesheetDayEntryList = useMemo(() => {
    if (shifts.length === 0) {
      return [];
    }
    return mapShiftsToDayEntryList(shifts);
  }, [shifts]);

  const { isEnabled: isPaidBreakExceptionEnabled } = useFeatureFlag('PPL-2119-paid-break-exception');

  return (
    <Card className="max-tablet-portrait:border-0 max-tablet-portrait:rounded-none !p-0">
      <div className="max-tablet-portrait:rounded-none max-tablet-portrait:-ml-16 max-tablet-portrait:-mr-16">
        <table className="w-full">
          <thead>
            <tr>
              <th
                colSpan={4}
                className="bg-surface-l3 py-12 px-16 text-18 text-left rounded-t-md max-tablet-portrait:rounded-none"
              >
                Time entered
              </th>
            </tr>
          </thead>
          <tbody className="border-collapse">
            {timesheetDayEntryList.map(timesheetDayEntry => (
              <React.Fragment key={`${timesheetDayEntry.day}-${timesheetDayEntry.month}`}>
                {/* Section Header Row */}
                <tr className="bg-surface-l2 border-t-1 border-b border-outline-l1">
                  <td className="py-12 px-16 text-left font-600">
                    {' '}
                    {timesheetDayEntry.weekDay} {timesheetDayEntry.day}/{timesheetDayEntry.month}/
                    {timesheetDayEntry.year}
                  </td>
                  <td className="py-12 pr-16 text-left"></td>
                  <td className="py-12 pr-16 text-right">Break</td>
                  <td className="py-12 pr-16 text-right">Hours</td>
                </tr>

                {/* Shift Entry Rows */}
                {timesheetDayEntry.shiftEntryData.map((timeEntry, index) => {
                  const shiftDate = timesheetDayEntry.shiftStartDate;
                  const shiftDateKey = shiftDate.toString();
                  const isLastShift = index === timesheetDayEntry.shiftEntryData.length - 1;
                  if (isPaidBreakExceptionEnabled && timeEntry.type === 'Ordinary') {
                    return (
                      <React.Fragment
                        key={`${shiftDateKey}-${timeEntry.type}-${timeEntry.startTime}-${timeEntry.endTime}`}
                      >
                        <TimesheetShiftEntryOrdinaryRow
                          shiftDate={shiftDate}
                          timeEntry={timeEntry}
                          isLastShift={isLastShift}
                        />
                      </React.Fragment>
                    );
                  }

                  return (
                    <React.Fragment
                      key={`${shiftDateKey}-${timeEntry.type}-${timeEntry.startTime}-${timeEntry.endTime}`}
                    >
                      <TimesheetShiftEntryRow timeEntry={timeEntry} isLastShift={isLastShift} />
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
